import { usePageConfigProviderContext } from "src/features/PageConfigProvider";
import { useTranslation } from "src/hooks";
import { useGenGridCol } from "src/utils/HelperComp";
import { TableColumnKey } from "../types/Table";
import useOperationButton from "./useOperationButton";
import useTotalBalanceCell from "./useTotalBalanceCell";
import useWalletCountCell from "./useWalletCountCell";

const useTableColumns = () => {
  const { translatePrefix } = usePageConfigProviderContext();
  const { t } = useTranslation(translatePrefix);
  const { renderOperationButtons } = useOperationButton();
  const { renderTotalBalanceCell } = useTotalBalanceCell();
  const { renderWalletCountCell } = useWalletCountCell();

  const columns = [
    useGenGridCol(TableColumnKey.Operation, t(TableColumnKey.Operation), {
      renderCell: renderOperationButtons,
    }),
    useGenGridCol(TableColumnKey.ChainName, t(TableColumnKey.ChainName)),
    useGenGridCol(TableColumnKey.Currency, t(TableColumnKey.Currency)),
    useGenGridCol(
      TableColumnKey.SmartAccountType,
      t(TableColumnKey.SmartAccountType),
      { minWidth: 150 },
    ),
    useGenGridCol(
      TableColumnKey.WalletMajorVersion,
      t(TableColumnKey.WalletMajorVersion),
      { minWidth: 150 },
    ),
    useGenGridCol(TableColumnKey.WalletsCount, t(TableColumnKey.WalletsCount), {
      renderCell: renderWalletCountCell,
    }),
    useGenGridCol(TableColumnKey.TotalBalance, t(TableColumnKey.TotalBalance), {
      minWidth: 180,
      renderCell: renderTotalBalanceCell,
    }),
    useGenGridCol(
      TableColumnKey.SpenderAddress,
      t(TableColumnKey.SpenderAddress),
      { minWidth: 350 },
    ),
  ];
  return { columns };
};

export default useTableColumns;
